import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Icon, Progress, Text } from "~/components-shared";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
const Scrollable = styled.div`
  overflow: auto;
  max-height: 230px;
  position: relative;
  padding-right: 1em;
`;
const StyledButton = styled(Button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const StyledAlert = styled(Alert)`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  overflow: hidden;
`;
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const SummaryCard = _ref => {
  let {
    dateFrom,
    dateTo,
    memberIds,
    widget,
    ...rest
  } = _ref;
  const [summary, setSummary] = useState(widget?.data?.summary);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  useEffect(() => {
    setSummary(widget?.data?.summary);
  }, [dateFrom, dateTo, memberIds, widget?.data?.summary]);
  const handleClick = () => {
    setLoading(true);
    setError(undefined);
    api.fetchMemberInsightsSummary({
      dateFrom,
      dateTo,
      memberIds
    }).then(response => {
      setSummary(response);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 3
    }
  }, "Summary"), error && /*#__PURE__*/React.createElement(StyledAlert, {
    severity: "danger",
    fullWidth: true
  }, error), summary ? /*#__PURE__*/React.createElement(Scrollable, null, /*#__PURE__*/React.createElement(Markdown, {
    fontSize: 4,
    lineHeight: 6,
    text: summary
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "100%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "95%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "30%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "80%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "95%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "30%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "100%"
  }), /*#__PURE__*/React.createElement(Progress, {
    s: {
      mb: 2
    },
    height: 5,
    maxWidth: "80%"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    color: "primary",
    onClick: handleClick,
    loading: loading,
    fontSize: 4,
    s: {
      px: 4,
      py: 3
    }
  }, "Get summary")), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })));
};
export default SummaryCard;